import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';



@Component({
  selector: 'rounds',
  templateUrl: './rounds.component.html',
  styleUrls: ['./rounds.component.scss']
})
export class RoundsComponent implements AfterViewInit, OnDestroy {
  public busy: boolean;
  // TODO - lazy, lazy, lazy, lazy.... make it an object
  public arr2D: any;
  public player: Player;
  public isDoubles: boolean = false;
  public fullName: string;

  constructor(private http: HttpClient, private userSvc: UserService) {
    this.busy = true;
    this.userSvc.getUser().subscribe(
      (resp) => {
        this.player = new Player(resp);
        this.fullName = this.player.firstName + ' ' + this.player.lastName;
      }
    );
    this.http.get(`/pairing/pairings`).subscribe(
      (resp: any[]) => {

        const maxRound = resp.reduce((accumlator, val, idx) => {
          if (val.round > accumlator) accumlator = val.round;
          return accumlator;
        }, 0);
        console.log('largest round is ', maxRound);
        this.arr2D = new Array(maxRound); //.fill(new Array());
        for (let r of resp) {
          if (null == this.arr2D[r.round - 1]) this.arr2D[r.round - 1] = [];
          this.arr2D[r.round - 1].push(r);
        }

        //this.pairings.sort((a: any, b: any) => a.round < b.round ? -1 : 1)
        console.log(this.arr2D);
        this.busy = false;
      }
    )
  }

  public getDateRange(round: number) {
    const d = new Date(2025, 1, 9);
    const d2 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + (7 * round));
    const d3 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate() + 6);
    return `${this.month(d2.getMonth())} ${d2.getDate()} to ${this.month(d3.getMonth())} ${d3.getDate()}`;
  }

  private month(m) {
    switch (m) {
      case 0: return 'Jan';
      case 1: return 'Feb';
      case 2: return 'Mar';
      case 3: return 'Apr';
      case 4: return 'May';
      case 5: return 'Jun';
      case 6: return 'Jul';
      case 7: return 'Aug';
      case 8: return 'Sept';
      case 9: return 'Oct';
      case 10: return 'Nov';
    }
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
  }


}
